import type { TweetListResponsePageAllOfThreeContentItemMediaLinksItemProjectInfoEngagementAllOf } from './tweetListResponsePageAllOfThreeContentItemMediaLinksItemProjectInfoEngagementAllOf';
import type { TweetListResponsePageAllOfThreeContentItemMediaLinksItemProjectInfoEngagementAllOfTwo } from './tweetListResponsePageAllOfThreeContentItemMediaLinksItemProjectInfoEngagementAllOfTwo';

/**
 * 프로젝트 참여 통계
 */
export type TweetListResponsePageAllOfThreeContentItemMediaLinksItemProjectInfoEngagement = TweetListResponsePageAllOfThreeContentItemMediaLinksItemProjectInfoEngagementAllOf & TweetListResponsePageAllOfThreeContentItemMediaLinksItemProjectInfoEngagementAllOfTwo;
